<template>
  <div>
    <v-form ref="form">
      <v-toolbar dense color="white">
        <v-toolbar-title>{{ screenTitle }}</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <error-message :error-object="errorObject" />
        <success-message :success-object="successObject" />
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-model="submitItem.disasterNo"
              :items="unfinishedDisasters"
              :rules="[rules.required]"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="災害名称"
              item-text="disaster_name"
              item-value="disaster_no"
              clearable
              outlined
              @change="changeDisaster"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-text-field
              :value="emergencyStatusName"
              label="緊急事態区分"
              placeholder=" "
              disabled
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="4" lg="3">
            <v-select
              v-model="submitItem.municipCodes"
              :items="municipalities"
              :rules="[rules.requiredMultiple]"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="市町村"
              item-text="municip_name"
              item-value="municip_code"
              clearable
              outlined
              multiple
              @change="changeMunicipality"
            >
            </v-select>
          </v-col>
          <v-col cols="12" sm="8" md="6" lg="6">
            <v-select
              v-model="submitItem.organizeIds"
              :items="organizations"
              :placeholder="config.PLACEHOLDER_SELECT"
              label="組織名"
              item-text="organize_name"
              item-value="organize_id"
              clearable
              outlined
              multiple
            >
            </v-select>
          </v-col>
        </v-row>
        <v-divider class="mb-1" />
      </v-container>
      <v-container fluid>
        <v-row>
          <v-col cols="6" md="3">
            <v-text-field
              v-model="submitItem.deliveryTitle"
              label="件名"
              :placeholder="config.PLACEHOLDER_INPUT"
              :rules="[rules.required]"
              v-bind="formControlProps(15)"
              outlined
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6" md="8" lg="6">
            <validation-observer
              ref="fileUploadObserver"
              v-slot="fileUploadObserverProps"
            >
              <v-dialog v-model="uploadDialog" persistent>
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-flex">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      @click="setEditedFileItems"
                      class="mx-2 mt-3"
                      color="primary"
                    >
                      ファイルの添付
                    </v-btn>
                    <v-tooltip
                      right
                      :open-on-hover="false"
                      color="grey lighten-4"
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          @click="on.click"
                          @blur="on.blur"
                          retain-focus-on-click
                        >
                          <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span style="color: black">
                        最大10個の添付ファイルが登録可能。<br />
                        ファイルサイズの合計が20Mバイト以内であること。<br />
                        以下の拡張子であること。<br />
                        .png、.gif、.jpeg、.jpg、.txt、.pdf<br />
                        動画ファイルはアップロード不可<br />
                      </span>
                    </v-tooltip>
                    <v-btn
                      class="mx-2 mt-3 ml-3"
                      color="primary"
                      @click="generateUrls"
                      v-if="
                        submitItem.attachFiles.length > 0 &&
                          submitItem.attachFiles[0].file
                      "
                      >添付ファイルURLの再貼付け</v-btn
                    >
                    <v-tooltip
                      right
                      :open-on-hover="false"
                      color="grey lighten-4"
                      v-if="
                        submitItem.attachFiles.length > 0 &&
                          submitItem.attachFiles[0].file
                      "
                    >
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          @click="on.click"
                          @blur="on.blur"
                          retain-focus-on-click
                        >
                          <v-icon>mdi-help-circle-outline</v-icon>
                        </v-btn>
                      </template>
                      <span style="color: black">
                        本文に貼り付けられた添付ファイルのURLを誤って消した場合等、<br />
                        再度URLを貼り付ける場合は「添付ファイルURLの再貼付け」ボタンより再度貼り付けてください。<br />
                      </span>
                    </v-tooltip>
                  </div>
                </template>
                <v-card>
                  <v-card-title></v-card-title>
                  <v-card-text>
                    <v-toolbar dense color="white">
                      <v-toolbar-title>ファイル添付</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn
                        class="mx-2"
                        color="primary"
                        @click="addFile"
                        :disabled="
                          editedFileItems.length > 9 ||
                            !fileUploadObserverProps.valid
                        "
                        >添付ファイルの追加</v-btn
                      >
                    </v-toolbar>
                    <v-data-table
                      :headers="filesHeaders"
                      :items="editedFileItems"
                      class="elevation-1 mt-2"
                      locale="ja-jp"
                      item-key="imageNo"
                      hide-default-footer
                      no-data-text="データはありません。"
                    >
                      <template v-slot:[`item.file`]="{ item }">
                        <validation-provider
                          v-slot="{ errors }"
                          rules="required|validExtensions"
                        >
                          <v-file-input
                            v-model="item.file"
                            :placeholder="config.PLACEHOLDER_FILE"
                            :accept="config.FILE_INPUT_ACCEPT"
                            :error-messages="errors"
                            prepend-icon="mdi-paperclip"
                            class="mt-2"
                            dense
                            v-bind="formControlProps()"
                            @change="changeFile(item)"
                          >
                            <template v-slot:selection="{ text }">
                              <v-chip small label color="primary">
                                {{ text }}
                              </v-chip>
                            </template>
                          </v-file-input>
                        </validation-provider>
                      </template>
                      <template v-slot:[`item.imageTitle`]="{ item }">
                        <v-text-field
                          v-model="item.imageTitle"
                          :placeholder="config.PLACEHOLDER_INPUT"
                          class="mt-2"
                          dense
                          v-bind="formControlProps(30)"
                        >
                        </v-text-field>
                      </template>
                    </v-data-table>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      class="mx-2"
                      color="primary"
                      @click="setFiles"
                      :disabled="!fileUploadObserverProps.valid"
                    >
                      添付
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      color="primary"
                      @click="uploadDialog = false"
                    >
                      キャンセル
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </validation-observer>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="8">
            <v-textarea
              v-model="submitItem.deliveryBody"
              counter="1000"
              maxlength="1000"
              label="通知文"
              :placeholder="config.PLACEHOLDER_INPUT"
              :rules="[rules.required]"
              outlined
            >
            </v-textarea>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <p style="margin: 5px 0 15px 0">
      プレビューボタンで確認の上、送信してください
      <v-tooltip right :open-on-hover="false" color="grey lighten-4">
        <template v-slot:activator="{ on }">
          <v-btn icon @click="on.click" @blur="on.blur" retain-focus-on-click>
            <v-icon>mdi-help-circle-outline</v-icon>
          </v-btn>
        </template>
        <span style="color: black">
          プレビュー画面について<br />
          本文とURLを同じ行に記載したり、同じ行にURLが2つ並ぶと、<br />
          正常にプレビューを表示することができません。<br />
          表示されない場合は、本文を見直して発信してください。<br />
        </span>
      </v-tooltip>
    </p>
    <v-btn
      :disabled="isDisabled('SUBMIT')"
      @click="submit"
      class="mx-2"
      color="primary"
    >
      送信
    </v-btn>
    <v-btn
      :disabled="isDisabled('TEMPORARILY_SAVED')"
      @click="execute('0')"
      class="mx-2"
      color="primary"
    >
      一時保存
    </v-btn>
    <v-btn @click="previewDialog = true" class="mx-2" color="primary">
      プレビュー
    </v-btn>
    <v-btn @click="onClickReturn" class="mx-2" color="primary">戻る</v-btn>
    <select-urls
      ref="selectUrls"
      :isShowSelect="true"
      :isShowAgreeButton="true"
    />
    <confirm-dialog ref="confirm" />
    <v-dialog v-model="previewDialog" max-width="600">
      <v-card>
        <v-card-title></v-card-title>
        <v-card-text>
          <template v-if="getPreview()">
            <p v-html="$sanitize(getPreview())"></p>
          </template>
          <template v-else>
            <p>通知文のプレビューが表示できません</p>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mx-2" color="primary" @click="previewDialog = false">
            戻る
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay" opacity="1" color="white" z-index="2147483647">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import Vue from "vue";
import sanitizeHTML from "sanitize-html";
import cloneDeep from "lodash/cloneDeep";
import orderBy from "lodash/orderBy";
import Disaster from "@/plugins/disaster";
import messageUtils from "@/mixins/message-utils";
import config from "@/js/const";
import { arrayCount } from "@/js/utils";
import { makeRandom, nullCheck } from "@/js/utils";
import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
import { DisasterTranslator } from "@/js/translators/disasterTranslator";
import { EmergencyClass } from "@/js/value-objects/emergency-class";
import { ScreenId } from "@/js/value-objects/screen-id";
import { ValidationObserver, ValidationProvider } from "vee-validate";

const allAreaRepository = RepositoryFactory.get("allArea");
const fixedPhraseRepository = RepositoryFactory.get("fixedPhrase");
const organizeMstRepository = RepositoryFactory.get("organizeMst");
const disasterInfoRepository = RepositoryFactory.get("disasterInfo");
const deliveryRepository = RepositoryFactory.get("disasterStaffDelivery");
const fileS3UploadRepository = RepositoryFactory.get("fileS3Upload");
const fileS3UrlRepository = RepositoryFactory.get("fileS3Url");

Vue.use(Disaster);

// サニタイズ設定
// プレビュー用にimgタグを許可
sanitizeHTML.defaults.allowedTags.push("img");
sanitizeHTML.defaults.allowedAttributes.img = ["src", "width"];
Vue.prototype.$sanitize = sanitizeHTML;

const DEFAULT_FILES = [
  {
    imageNo: -1,
    imageTitle: "",
    imageFileName: "",
    s3object: makeRandom(6),
    file: null,
    fileUploadFlag: true
  }
];
export default {
  mixins: [messageUtils],
  components: {
    ValidationProvider,
    ValidationObserver,
    SelectUrls: () => import("@/components/SelectUrls"),
    ConfirmDialog: () => import("@/components/ConfirmDialog"),
    ErrorMessage: () => import("@/components/ErrorMessage"),
    SuccessMessage: () => import("@/components/SuccessMessage")
  },
  props: {
    item: {
      type: Object,
      required: false,
      default: undefined
    }
  },
  data: () => ({
    overlay: false,
    orderScreenMode: "",
    screenId: ScreenId.SF1803,
    submitItem: {
      disasterNo: "",
      emergCls: EmergencyClass.NL,
      deliveryBody: "",
      deliveryTitle: "",
      municipCodes: [],
      organizeIds: [],
      attachFiles: DEFAULT_FILES,
      detachFiles: []
    },
    uploadDialog: false,
    selectedUrls: [],
    editedFileItems: [],
    config: config,
    fixedPhrase: [],
    unfinishedDisasters: [],
    municipalities: [],
    baseOrganizations: [],
    organizations: [],
    previewDialog: false,
    rules: {
      required: value => !!value || "必須項目です。",
      requiredMultiple: value => value.length !== 0 || "必須項目です。"
    }
  }),

  computed: {
    screenTitle() {
      return ScreenId.getScreenTitle(this.screenId);
    },

    /**
     * ボタンの非活性制御（true：非活性、false：活性）
     */
    isDisabled() {
      return function(buttonId) {
        let disabled = false;
        switch (buttonId) {
          case "SUBMIT":
            // 災害名称・市町村・件名・通知文が設定されていれば送信を活性
            if (
              !this.submitItem.disasterNo ||
              !this.submitItem.deliveryTitle ||
              this.submitItem.municipCodes.length == 0 ||
              !this.submitItem.deliveryBody
            ) {
              disabled = true;
            }
            break;
          case "TEMPORARILY_SAVED":
            // 災害名称が設定されていれば一時保存を活性
            if (!this.submitItem.disasterNo) {
              disabled = true;
            }
            break;
          default:
            break;
        }
        return disabled;
      };
    },

    filesHeaders() {
      return [
        {
          text: "ID",
          align: " d-none",
          value: "imageNo",
          sortable: false
        },
        {
          text: "ファイル",
          value: "file",
          sortable: false
        },
        {
          text: "タイトル",
          value: "imageTitle",
          sortable: false
        }
      ];
    },

    emergencyStatusName() {
      return EmergencyClass.factory(this.submitItem.emergCls).toName();
    },

    formControlProps: () => {
      return function(counter = null) {
        return this.$formControlProps(false, counter);
      };
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    async initialize() {
      this.overlay = true;
      // モード情報の設定
      this.orderScreenMode = this.$route.name;

      await Promise.all([
        // 災害情報（未終結）
        disasterInfoRepository.unfinished(this.screenId),
        // 市町村一覧
        allAreaRepository.getAllArea(),
        // 組織情報
        organizeMstRepository.list(this.screenId),
        // 定型文情報
        fixedPhraseRepository.list()
      ])
        .then(values => {
          this.unfinishedDisasters = DisasterTranslator.sortByDisasterNo(
            values[0].data.results,
            true
          );
          this.municipalities = values[1].data.results[0].municipalities
            .concat(values[1].data.results[1].municipalities)
            .filter(m => m.disp_flg !== "1");
          const sortOrganizations = orderBy(values[2].data.results, [
            "disp_no"
          ]);
          this.baseOrganizations = sortOrganizations.map(organization => {
            const municipInfo = this.municipalities.find(
              municipality =>
                municipality.municip_code === organization.municip_code
            );
            if (municipInfo) {
              organization.organize_name =
                municipInfo.municip_name + " : " + organization.organize_name;
            }
            return organization;
          });
          this.fixedPhrase = values[3].data.results.filter(
            phrase =>
              phrase.staff_only_flg === "1" && phrase.phrases.length != 0
          );
          this.submitItem.disasterNo = this.$disaster.disaster_no;
        })
        .catch(e => {
          this.handleError(e, this.screenId, "manager-order-management");
        });

      if (this.item) {
        // 編集」「コピーして編集」の場合、現在のデータを画面に表示
        this.submitItem.disasterNo = this.item.disaster_no;
        this.submitItem.emergCls = this.item.emerg_cls;
        // 現在の緊急事態区分を設定
        const disasterItem = this.unfinishedDisasters.find(
          obj => obj.disaster_no === this.item.disaster_no
        );
        if (disasterItem) {
          this.submitItem.emergCls = disasterItem.emerg_cls;
        } else {
          // 終結している場合は初期化する
          this.submitItem.disasterNo = "";
          this.submitItem.emergCls = EmergencyClass.NL;
          this.$refs.form.resetValidation();
        }
        this.submitItem.municipCodes = this.item.dest.municip_codes;
        // 組織の一覧を変更
        if (this.item.dest.municip_codes) {
          this.organizations = this.baseOrganizations.filter(organization =>
            this.item.dest.municip_codes.includes(organization.municip_code)
          );
        }
        this.submitItem.organizeIds = this.item.dest.organize_ids;
        this.submitItem.deliveryTitle = this.item.delivery_title;
        this.submitItem.deliveryBody = this.item.delivery_body;
        // 添付ファイル
        const attachFiles = this.item.attach_files;
        if (arrayCount(attachFiles) > 0) {
          this.submitItem.attachFiles = attachFiles.map(attachFile => {
            const pushItem = {
              imageNo: attachFile.image_no,
              imageTitle: attachFile.image_title,
              imageFileName: attachFile.image_filename,
              file: new File([""], attachFile.image_filename),
              fileUploadFlag: false,
              s3object: attachFile.s3object
            };
            return pushItem;
          });

          // URL作成API呼び出し
          const s3objects = this.submitItem.attachFiles.map(
            item => item.s3object
          );
          const list = await fileS3UrlRepository.create(
            this.screenId,
            s3objects,
            process.env.VUE_APP_BUCKET_NAME_PUBLIC
          );
          this.setFileS3Urls(list);
        }
      } else {
        // 「新規登録の場合」
        // 緊急事態区分変更
        const checkEmergCls = this.$disaster.emerg_cls;
        this.submitItem.emergCls = checkEmergCls
          ? checkEmergCls
          : EmergencyClass.NL;
        // 件名・通知文変更
        this.setFixedPhrase(checkEmergCls);
      }
      this.overlay = false;
    },

    /**
     * 件名・通知文に定型文を設定する
     */
    setFixedPhrase(checkEmergCls) {
      const checkFixedPhrase = this.fixedPhrase.find(
        phrase => phrase.emerg_cls === checkEmergCls
      );
      if (checkFixedPhrase) {
        const phraseInfo = checkFixedPhrase.phrases.find(
          phrase => phrase.locale === "ja"
        );
        if (phraseInfo) {
          this.submitItem.deliveryTitle = phraseInfo.title;
          this.submitItem.deliveryBody = phraseInfo.phrase;
        }
      }
    },

    /**
     * URLの設定
     */
    setFileS3Urls(list) {
      this.submitItem.attachFiles.forEach(item => {
        const fileS3Object = list.data.results.find(fileS3Url => {
          return fileS3Url.s3object === item.s3object;
        });
        let url = "";
        if (fileS3Object && fileS3Object.url) {
          url = fileS3Object.url;
        }
        item.url = url;
      });
    },

    /**
     * 登録用ペイロード作成
     */
    toCreatePayload(attachFiles, deliveryStatus = "0") {
      const payload = {
        disaster_no: this.submitItem.disasterNo,
        emerg_cls: this.submitItem.emergCls,
        delivery_status: deliveryStatus,
        delivery_title: this.submitItem.deliveryTitle,
        delivery_body: this.submitItem.deliveryBody,
        dest: {
          municip_codes: this.submitItem.municipCodes,
          organize_ids: this.submitItem.organizeIds
        },
        attach_files: attachFiles
      };
      return payload;
    },

    /**
     * 更新用ペイロード作成
     */
    toUpdatePayload(attachFiles, detachFiles, deliveryStatus = "0") {
      const payload = {
        delivery_no: this.item.delivery_no,
        disaster_no: this.submitItem.disasterNo,
        emerg_cls: this.submitItem.emergCls,
        hash: this.item.hash,
        delivery_status: deliveryStatus,
        delivery_title: this.submitItem.deliveryTitle,
        delivery_body: this.submitItem.deliveryBody,
        dest: {
          municip_codes: this.submitItem.municipCodes,
          organize_ids: this.submitItem.organizeIds
        },
        attach_files: attachFiles,
        detach_files: detachFiles
      };
      return payload;
    },

    /**
     *添付ファイルURLの再貼付けボタン押下時処理
     */
    async generateUrls() {
      // URLダイアログを表示
      this.$refs.selectUrls.open(this.submitItem.attachFiles);
    },

    /**
     * 編集用ファイルアイテムの設定
     */
    setEditedFileItems() {
      this.editedFileItems = cloneDeep(this.submitItem.attachFiles);
    },

    /**
     * ファイル添付ダイアログ（設定）
     */
    async setFiles() {
      this.overlay = true;
      this.uploadDialog = false;

      // 削除用ファイル追加
      if (
        !(
          this.submitItem.attachFiles.length == 1 &&
          !this.submitItem.attachFiles[0].file
        )
      ) {
        // DEFAULTデータのみの場合を除いたデータを対象とする
        this.submitItem.attachFiles
          .filter(attachFile => {
            // ファイルが削除or更新された場合（S3オブジェクトが一致するデータが存在しない場合）
            return !this.editedFileItems.some(file => {
              return file.s3object === attachFile.s3object;
            });
          })
          .map(filterItem => {
            this.submitItem.detachFiles.push(filterItem);
          });
      }
      const hasFiles = this.editedFileItems.some(file => {
        return file.file;
      });
      if (!hasFiles) {
        // 添付ファイルが存在しない場合
        this.submitItem.attachFiles = cloneDeep(DEFAULT_FILES);
      } else {
        // 添付ファイルが存在する場合
        this.submitItem.attachFiles = cloneDeep(this.editedFileItems);
        // ファイルアップロード処理
        await Promise.all(
          this.submitItem.attachFiles
            .filter(item => {
              return item.fileUploadFlag;
            })
            .map(async attachFile => {
              // バイナリデータ読み込み
              await this.readBinary(attachFile.file);
              // ファイルアップロードAPI呼び出し
              if (attachFile.file) {
                // s3objectに拡張子情報を追加
                const splits = attachFile.file.name.split(".");
                attachFile.s3object =
                  attachFile.s3object + "." + splits[splits.length - 1];
                const base64 = attachFile.file.binary;
                await fileS3UploadRepository.create(
                  this.screenId,
                  attachFile.s3object,
                  process.env.VUE_APP_BUCKET_NAME_PUBLIC,
                  base64
                );
              }
            })
        )
          .catch(e => {
            this.handleUpdateError(e);
          })
          .finally(() => {
            // アップロードフラグをfalseに変更
            this.submitItem.attachFiles.forEach(file => {
              file.fileUploadFlag = false;
            });
          });
      }
      // URL作成API呼び出し
      const s3objects = this.submitItem.attachFiles.map(item => item.s3object);
      const list = await fileS3UrlRepository
        .create(
          this.screenId,
          s3objects,
          process.env.VUE_APP_BUCKET_NAME_PUBLIC
        )
        .catch(e => {
          this.handleUpdateError(e);
        });
      // URL情報が取得できた場合のみ値を設定
      if (list) {
        this.setFileS3Urls(list);
        // 通知文の末尾に追加
        this.submitItem.attachFiles.forEach(item => {
          this.submitItem.deliveryBody += `\n${item.url}`;
        });
        if (this.submitItem.deliveryBody.length > 1000) {
          // 1000文字を超える場合は、1000文字で切り取る
          this.submitItem.deliveryBody = this.submitItem.deliveryBody.substr(
            0,
            1000
          );
        }
      }
      this.overlay = false;
    },

    /**
     * バイナリデータ作成
     * @param {*} file ファイル
     */
    readBinary(file) {
      return new Promise(resolve => {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.addEventListener("load", e => {
          file.binary = e.target.result.replace(/data:.*\/.*;base64,/, "");
          resolve();
        });
      });
    },

    /**
     * 添付ファイル変更時処理
     * @param {*} item 編集中アイテム
     */
    changeFile(item) {
      let targetItem = this.editedFileItems.find(file => {
        return file.imageNo === item.imageNo;
      });
      if (targetItem) {
        // ファイル名を設定
        if (targetItem.file) {
          targetItem.imageFileName = targetItem.file.name;
          targetItem.s3object = makeRandom(6);
          targetItem.fileUploadFlag = true;
        }
      }
    },

    onClickReturn() {
      this.$router.push("/manager-order");
    },

    /**
     * 更新/登録API実行（送信/一時保存ボタン押下時）
     * @param {*} deliveryStatus 一時保存（"0"：一時保存,"1"：送信）
     */
    async execute(deliveryStatus = "0") {
      this.overlay = true;
      // 添付ファイル情報（初期表示時との差分のみ）
      let attachFiles = [];
      if (this.submitItem.attachFiles.length >= 1) {
        // 添付ファイルが1つ以上の場合
        if (
          !(
            this.submitItem.attachFiles.length == 1 &&
            !this.submitItem.attachFiles[0].file
          )
        ) {
          // 添付ファイルが1つで、かつデフォルトファイルの場合以外
          if (this.isCreate() || this.isDuplicate()) {
            // 「新規登録」「コピーして編集」の場合（現在の添付ファイル情報を参照する）
            attachFiles = this.submitItem.attachFiles;
          } else {
            // 「編集」の場合（初期表示からの追加分を添付ファイル情報とする）
            attachFiles = this.submitItem.attachFiles.filter(attachFile => {
              if (
                this.item &&
                this.item.attach_files &&
                this.item.attach_files.length > 0
              ) {
                // 初期表示時との差分のみに絞る
                return !this.item.attach_files.some(file => {
                  return file.s3object === attachFile.s3object;
                });
              }
              return true;
            });
          }
          // APIリクエストの形式に変換
          attachFiles = attachFiles.map(item => {
            let mapItem = {};
            if (!nullCheck(item.imageTitle)) {
              // タイトル
              mapItem.image_title = item.imageTitle;
            }
            if (!nullCheck(item.imageFileName)) {
              // イメージファイル名
              mapItem.image_filename = item.imageFileName;
            }
            if (!nullCheck(item.s3object)) {
              // s3オブジェクト
              mapItem.s3object = item.s3object;
            }
            return mapItem;
          });
        }
      }

      if (this.isCreate() || this.isDuplicate()) {
        // 「編集」以外(「新規登録」「コピーして編集」)の場合
        // 登録API呼び出し
        const payload = this.toCreatePayload(attachFiles, deliveryStatus);
        this.clearMessage();
        await deliveryRepository
          .create(ScreenId.SF1803, payload)
          .then(response => {
            this.handleSuccess(response, "manager-order-management");
          })
          .catch(e => {
            this.handleError(e, this.screenId, "manager-order-management");
          });
      } else {
        // 「編集」の場合
        // 削除ファイル情報
        let detachFiles = [];
        if (this.item && this.item.attach_files) {
          detachFiles = this.submitItem.detachFiles
            .filter(detachFile => {
              return this.item.attach_files.some(file => {
                return file.s3object === detachFile.s3object;
              });
            })
            .map(filterItem => {
              const targetItem = this.item.attach_files.find(file => {
                return file.s3object === filterItem.s3object;
              });
              let mapItem = {
                image_no: targetItem.image_no,
                s3object: targetItem.s3object
              };
              if (!nullCheck(targetItem.image_title)) {
                mapItem.image_title = targetItem.image_title;
              }
              if (!nullCheck(targetItem.image_filename)) {
                mapItem.image_filename = targetItem.image_filename;
              }
              return mapItem;
            });
        }
        // 更新API呼び出し
        const payload = this.toUpdatePayload(
          attachFiles,
          detachFiles,
          deliveryStatus
        );
        this.clearMessage();
        await deliveryRepository
          .update(this.screenId, payload)
          .then(response => {
            this.handleSuccess(response, "manager-order-management");
          })
          .catch(e => {
            this.handleError(e, this.screenId, "manager-order-management");
          });
      }
    },

    /**
     * 送信ボタン押下時処理
     */
    async submit() {
      const message = "送信してもよろしいですか?";
      const result = await this.$refs.confirm.open(message, "送信");
      if (!result) {
        return;
      }
      this.execute("1");
    },

    /**
     * ファイル添付ダイアログ（添付ファイルの追加）
     */
    addFile() {
      this.editedFileItems.push({
        imageNo: null,
        imageTitle: "",
        imageFileName: "",
        s3object: makeRandom(6),
        file: null,
        fileUploadFlag: true
      });

      let fileNo = -1;
      this.editedFileItems
        .filter(item => {
          // ItemKeyの重複を避けるため添付ファイルの追加時はnullを設定している
          return item.imageNo == null || item.imageNo < 0;
        })
        .forEach(filterItem => {
          filterItem.imageNo = fileNo;
          fileNo--;
        });
    },

    /**
     * 災害名称変更時の処理
     */
    changeDisaster(value) {
      const disasterItem = this.unfinishedDisasters.find(
        obj => obj.disaster_no === value
      );
      if (disasterItem) {
        // 緊急事態区分変更
        this.submitItem.emergCls = disasterItem.emerg_cls;
        this.setFixedPhrase(disasterItem.emerg_cls);
      } else {
        this.submitItem.emergCls = EmergencyClass.NL;
      }
    },

    /**
     * 市町村変更時の処理
     */
    changeMunicipality(value) {
      // 組織の一覧を変更
      this.organizations = this.baseOrganizations.filter(organization =>
        value.includes(organization.municip_code)
      );
      // 選択済みの組織の値を変更
      const organizeIdList = this.organizations.map(
        organization => organization.organize_id
      );
      this.submitItem.organizeIds = this.submitItem.organizeIds.filter(
        organizeId => organizeIdList.includes(organizeId)
      );
    },

    /**
     * 通知文のプレビューを取得する
     */
    getPreview() {
      const deliveryBodyList = this.submitItem.deliveryBody.split(/\r\n|\r|\n/);
      const pattern = /^http.*(.png|.jpeg|.jpg)$/i;
      let preview = "";
      deliveryBodyList.forEach(deliveryBody => {
        if (pattern.test(deliveryBody)) {
          preview += `<img width='50%' src='${deliveryBody}'><br>`;
        } else {
          preview += `<p>${deliveryBody}</p>`;
        }
      });
      return preview;
    },

    /**
     * モード判定（新規作成）
     */
    isCreate() {
      return this.orderScreenMode === "manager-order-create";
    },

    /**
     * モード判定（コピーして編集）
     */
    isDuplicate() {
      return this.orderScreenMode === "manager-order-duplicate";
    }
  },

  watch: {
    selectedUrls: {
      immediate: true,
      handler: function(value) {
        if (value && Array.isArray(value) && value.length > 0) {
          // 選択されたURLを通知文に追加する
          value.forEach(url => {
            this.submitItem.deliveryBody += `\n${url.url}`;
          });
          if (this.submitItem.deliveryBody.length > 1000) {
            // 1000文字を超える場合は、1000文字で切り取る
            this.submitItem.deliveryBody = this.submitItem.deliveryBody.substr(
              0,
              1000
            );
          }
        }
      }
    }
  }
};
</script>
